import { Fragment } from "react";

import { BCPNode } from "./bcp";

export const getBusinessUnitHierarchy = (bcp: BCPNode, mapBcpName: (bcp: BCPNode) => BCPNode) => {
  const mappedBcp = mapBcpName(bcp);

  const values = [mappedBcp.brand];

  if (bcp.category !== "default") {
    values.push(mappedBcp.category);
  }

  if (bcp.product !== "default") {
    values.push(mappedBcp.product);
  }

  return values.map((value, index) => (
    <Fragment key={index}>
      {index > 0 && " > "}
      <span style={{ fontWeight: index === values.length - 1 ? 600 : "normal" }}>{value}</span>
    </Fragment>
  ));
};
